// Управление всплывающими уведомлениями: «Закрыть все» (только тосты — складские проблемы
// в /problems не трогает) + «Ещё N», когда часть уведомлений в очереди сверх лимита.
// Не путать: «закрыть тост» ≠ «отметить просмотренным» ≠ «решить складскую проблему» —
// эта панель только про первое; вторая и третья сущность живут в /problems.
import { Link } from 'react-router';
import { Anchor, Button, Group, Paper, Text } from '@mantine/core';
import { notifications, useNotifications } from '@mantine/notifications';

export function NotificationControls() {
  const { notifications: visible, queue } = useNotifications();
  const total = visible.length + queue.length;
  if (total === 0) return null;

  return (
    <Paper
      withBorder shadow="sm" radius="md" p="xs"
      pos="fixed" top={68} right={16} className="notify-controls"
      style={{ zIndex: 400, maxWidth: 380 }}
      role="region" aria-label="Управление уведомлениями"
    >
      <Group justify="space-between" gap="sm" wrap="nowrap">
        <Text size="xs" c="dimmed">
          Показано {visible.length} из {total}
          {queue.length > 0 && <> · <Anchor component={Link} to="/problems" size="xs">ещё {queue.length}</Anchor></>}
        </Text>
        <Button size="compact-xs" variant="light" color="red" onClick={() => notifications.clean()}
          aria-label="Закрыть все всплывающие уведомления">
          Закрыть все
        </Button>
      </Group>
    </Paper>
  );
}
